import React from 'react'
import { Button, Modal } from 'react-bootstrap'

export default function TutorialModal({show, tutorial, handleClose}) {
  return (
    <Modal size='xl' show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{ tutorial.title }</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <iframe title={tutorial.title} width="100%" height={window.innerHeight / 1.5}
          src={tutorial.link ? tutorial.link : "https://www.youtube.com/embed/tgbNymZ7vqY"}>
        </iframe>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
